import React from "react";
import {EyeInvisibleOutlined} from "@ant-design/icons";
import {Tooltip} from "@clockout-dev/design-elements";
import styles from "../styles/pills.module.scss";

/**
 * Gray "Silent in production" pill with an explanatory tooltip. Attached to
 * fraud signals members never see — production redacts them into internal
 * fraud tickets only.
 */
function SilentBadge() {
    return (
        <Tooltip title="Members never see this signal in production — it only feeds internal fraud tickets.">
            <span className={`${styles.tag} ${styles.silentBadge}`}>
                <EyeInvisibleOutlined className={styles.silentIcon} />
                Silent in production
            </span>
        </Tooltip>
    );
}

export default SilentBadge;
